// ── runOffer ──────────────────────────────────────────────────────────────────
// Someone hammering the Next Up "Watched" button is marking a run one episode at a
// time. The friction telemetry saw it as a string of rage taps on The Last Ship
// (2026-10-23: bursts at S2·E10, E13, S3·E3, E6 … every third episode, one person):
// three quick taps, a breath, three more. The faster doors (drag down the rings, ⋯ →
// Mark the season) were never found. So after a burst, offer the run once.
//
// Pure: a tap log in, a verdict out. Tested in runOffer.test.js.
export const BURST_TAPS = 3
export const BURST_WINDOW_MS = 6000

// Returns { taps, trigger }: the pruned tap log and whether this tap completed a burst.
export function noteTap(taps, now = Date.now()) {
  const kept = (taps || []).filter(t => now - t <= BURST_WINDOW_MS)
  kept.push(now)
  return { taps: kept, trigger: kept.length >= BURST_TAPS }
}

// The offer's targets: every aired episode after the one being hammered, in order, so
// the person picks "I'm caught up to E13" instead of being handed "the rest of the
// season" (2026-10-30: two new members each pressed Watched ~90 times in a row; the
// one offer they saw was season-only and once-per-session, and they went back to
// hammering). `eps` = [{ episode_number, air_date }], `from` = the next-up episode,
// `today` = 'YYYY-MM-DD'. Returns [] when there is nothing past `from` to sweep.
export function runTargets(eps, from, today) {
  return (eps || [])
    .filter(e => e && e.episode_number >= from && (!e.air_date || e.air_date <= today))
    .map(e => e.episode_number)
    .sort((a, b) => a - b)
}
